import { getQueryParams } from '../routing/getQueryParams';
const EXPERIMENT_BACKDOOR_PARAM = 'exp-disabled';
export const experimentsEnabled = () => {
  const queryParams = getQueryParams();
  const manuallyDisabled = !!queryParams[EXPERIMENT_BACKDOOR_PARAM];
  return !manuallyDisabled;
};